import { Loader } from '@trackman/web-shared-components';
import '../../CommonStyles.scss';
import './NoData.scss';

export const NoData = ({ loading, error, noData }: { loading: boolean; error: boolean; noData: boolean }) => {
  return (
    <div className='no-data'>
      {loading && <Loader size='large' />}
      {error && <p>Failed to load data.</p>}
      {noData && !loading && !error && <p>No data available.</p>}
    </div>
  );
};
